import React, { Fragment, useState, useCallback } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import { Row, Card, CardBody, Alert } from "reactstrap";
import Fullscreen from "Components/Fullscreen";

export default function AlertsPage() {
  const [state, setState] = useState({
    visible: true,
    text: "This is alert — check it out!",
    textLink: "This is alert with link - ",
    link: "click here",
    heading: "Well done!",
    description:
      "Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.",
    footerText:
      "Whenever you need to, be sure to use margin utilities to keep things nice and tidy."
  });

  const onDismiss = useCallback(() => {
    setState((s) => ({ ...s, visible: false }));
  }, []);

  return (
    <Fragment>
      <Row>
        <Colxx xxs="12">
          <BreadcrumbContainer
            heading={<IntlMessages id="menu.player" />}
          />
          <div className="float-right">
            <Fullscreen />
          </div>
          <Separator className="mb-5" />
        </Colxx>
      </Row>

      {/* Alerts */}
      <Row>
        <Colxx xl="12" className="pl-0 pr-0 mb-5">
          <div className="pr-3 pl-3">
            <Card>
              <div>
                <CardBody>
                  <Alert color="primary">
                    {state.textLink} <a href="#">{state.link}</a>
                  </Alert>
                  <Alert color="secondary">
                    {state.textLink} <a href="#">{state.link}</a>
                  </Alert>
                  <Alert color="success">
                    {state.textLink} <a href="#">{state.link}</a>{" "}
                  </Alert>
                  <Alert color="danger">
                    {state.textLink} <a href="#">{state.link}</a>{" "}
                  </Alert>
                  <Alert color="warning">
                    {state.textLink} <a href="#">{state.link}</a>{" "}
                  </Alert>
                  <Alert color="info">
                    {state.textLink} <a href="#">{state.link}</a>{" "}
                  </Alert>
                  <Alert color="light">
                    {state.textLink} <a href="#">{state.link}</a>{" "}
                  </Alert>
                  <Alert color="dark">
                    {state.textLink} <a href="#">{state.link}</a>{" "}
                  </Alert>
                </CardBody>
              </div>
            </Card>
          </div>
        </Colxx>
      </Row>
      {/* Alerts Ends Here */}

      {/* Alerts */}
      <Row>
        <Colxx xl="12" className="pl-0 pr-0 mb-5">
          <div className="pr-3 pl-3">
            <Card>
              <div>
                <CardBody>
                  <Alert color="primary">{state.text}</Alert>
                  <Alert color="secondary">{state.text}</Alert>
                  <Alert color="success">{state.text} </Alert>
                  <Alert color="danger">{state.text} </Alert>
                  <Alert color="warning">{state.text} </Alert>
                  <Alert color="info">{state.text} </Alert>
                  <Alert color="light">{state.text} </Alert>
                  <Alert color="dark">{state.text} </Alert>
                </CardBody>
              </div>
            </Card>
          </div>
        </Colxx>
      </Row>
      {/* Alerts Ends Here */}

      {/* Alerts */}
      <Row>
        <Colxx xl="12" className="pl-0 pr-0 mb-5">
          <div className="pr-3 pl-3">
            <Card>
              <div>
                <CardBody>
                  <Alert color="success">
                    <h4 className="alert-heading">{state.heading}</h4>
                    <p>{state.description}</p>
                    <hr />
                    <p className="mb-0">{state.footerText}</p>
                  </Alert>
                </CardBody>
              </div>
            </Card>
          </div>
        </Colxx>
      </Row>

      {/* Alerts */}
      <Row>
        <Colxx xl="12" className="pl-0 pr-0 mb-5">
          <div className="pr-3 pl-3">
            <Card>
              <div>
                <CardBody>
                  <Alert
                    color="info"
                    isOpen={state.visible}
                    toggle={onDismiss}
                  >
                    I am an alert and I can be dismissed!
                  </Alert>
                </CardBody>
              </div>
            </Card>
          </div>
        </Colxx>
      </Row>

      {/* Alerts Ends Here */}
    </Fragment>
  );
}
